var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexBanner"},[(_vm.data.length)?_c('el-carousel',{attrs:{"height":"500px","interval":7000}},_vm._l((_vm.data),function(item){return _c('el-carousel-item',{key:item.picUrl},[_c('img',{attrs:{"src":item.picUrl,"alt":""}})])}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-066377c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header-banner/index.vue
// module id = null
// module chunks = 